(function(){
  // JS minimal pour le slider mobile de la section Ghost
  function initGhostSlider(sectionEl){
    var container = sectionEl.querySelector('[data-ghost-slider]');
    var btnNext = sectionEl.querySelector('[data-ghost-next]');
    var btnPrev = sectionEl.querySelector('[data-ghost-prev]');
    if(!container || !btnNext) return;

    function isMobile(){ return window.matchMedia('(max-width: 749px)').matches; }

    function updateVisibility(){
      btnNext.style.display = isMobile() ? 'block' : 'none';
    }

    // scroll by one visible slide (approx container width * 0.8)
    btnNext.addEventListener('click', function(){
      var scrollAmount = Math.max(container.clientWidth * 0.8, 200);
      // Smooth scroll
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
    btnPrev.addEventListener('click', function(){
      var scrollAmount = Math.max(container.clientWidth * 0.8, 200);
      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    window.addEventListener('resize', updateVisibility);
    updateVisibility();
  }

  // Initialize for each section instance on DOMContentLoaded
  function initAll(){
    var sections = document.querySelectorAll('.section-ghost');
    sections.forEach(function(section){ initGhostSlider(section); });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

